export const SYNC_COMPLETE_ANIMATION_DURATION = 2000;
